import request from '@/utils/request'
import store from '@/store'
const url_prefix = process.env.VUE_APP_API_URL

// 获取知识库列表
export function getKnowledgeList(params) {
  return request(
    {
      url: `${url_prefix}/knowledge/list`,
      method: 'get',
      params
    },
    {
      loading: false
    }
  )
}
// 上传
export function uploadKnowledge({ file, item, cancelTokenSource }) {
  const formData = new FormData()
  if (file) {
    formData.append('file', file)
  }
  return request(
    {
      url: `${url_prefix}/knowledge/upload`,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: formData,
      timeout: 180000,
      onUploadProgress: progressEvent => {
        const index = store.state.CloudKnowledge.uploadingFileList.findIndex(
          v => v.uid === item.uid
        )
        let percent = store.state.CloudKnowledge.uploadingFileList[index].percent
        const complete = parseFloat(((progressEvent.loaded / progressEvent.total) * 100).toFixed(2))
        console.log(index, complete)
        if (complete >= 80) {
          const timer = setInterval(() => {
            percent = parseFloat((percent + (100 - percent) * 0.2).toFixed(2))
            if (percent > 99.99 || !store.state.CloudKnowledge.uploadingFileList[index]) {
              timer && window.clearInterval(timer)
              return
            }
            store.commit('CloudKnowledge/SET_FILE', { item, val: { percent } })
          }, 1000)
        } else {
          percent = complete
          store.commit('CloudKnowledge/SET_FILE', { item, val: { percent } })
        }
      },
      cancelToken: cancelTokenSource?.token
    },
    {
      loading: false,
      errorMessageShow: false
    }
  )
}
// 删除
export function remove(params) {
  return request({
    url: `${url_prefix}/knowledge/delete`,
    method: 'get',
    params
  })
}

// 下载
export function download(params) {
  return request({
    url: `${url_prefix}/knowledge/download`,
    method: 'get',
    params
  })
}

// 同步云盘
export function syncCloud(data) {
  return request(
    {
      url: `${url_prefix}/knowledge/upload_client`,
      method: 'post',
      data
    },
    {
      loading: false,
      errorMessageShow: false
    }
  )
}

// 下载高清大图
export function downloadHD(data, signal) {
  return request(
    {
      url: `${url_prefix}/member-api/image/hd_img`,
      method: 'post',
      data,
      signal,
      timeout: 60000
    },
    {
      loading: false
    }
  )
}
